import { getAxiosInstance } from '@rover/rsdk/src/modules/Network/axios';
import type { Snakeify } from '@rover/rsdk/src/modules/Network/object-utilities';
import { camelize } from '@rover/rsdk/src/modules/Network/object-utilities';
import { SeoSlugEnum } from '@rover/shared/js/constants/seo';
import type { FetchCitiesAndNeighborhoodsResponse } from '@rover/types';
import { fullApiUrl } from '@rover/utilities/apiUrl';

import DefaultAPIErrorHandler from './DefaultAPIErrorHandler';

export type GetOptions = (
  | {
      countryCode?: never;
      countryUrlPrefix: string;
    }
  | {
      countryCode: string;
      countryUrlPrefix?: never;
    }
) & {
  serviceType: SeoSlugEnum | null;
};

export const CITIES_AND_NEIGHBORHOODS_URL: string = fullApiUrl('cities-and-neighborhoods/');

const buildUrl = ({ countryCode, countryUrlPrefix, serviceType }: GetOptions) => {
  let url = CITIES_AND_NEIGHBORHOODS_URL;
  url += countryCode ? `?country_code=${countryCode}` : `?country_url_prefix=${countryUrlPrefix}`;
  if (serviceType) {
    url += `&service_type=${serviceType}`;
  }
  return url;
};

export const get = async (getOptions: GetOptions): Promise<FetchCitiesAndNeighborhoodsResponse> => {
  const ai = getAxiosInstance();

  const url = buildUrl(getOptions);

  try {
    const { data } = await ai.get<Snakeify<FetchCitiesAndNeighborhoodsResponse>>(url);
    return camelize(data, true) as FetchCitiesAndNeighborhoodsResponse;
  } catch (e: any) {
    return DefaultAPIErrorHandler(e, 'There was an error while fetching cities and neighborhoods.');
  }
};
